export default "__VITE_ASSET__5Ke2aCrD__"